import Paper from '@aura/components/paper'
import clsx from 'clsx'
import { withStyles } from '@aura/components/styles'
import Typography from '@aura/components/typography'
import PropTypes from 'prop-types'
import styles from './styles'


const RegistrationContainer = ({
    children,
    classes,
    isMata,
    title,
    verbiage
}) => {

    const mobile = window.innerWidth <= 670

    return (<Paper spacing={2} className={classes.registrationContainer}>
        {isMata && <div className={classes.titleHeader}>
            <Typography className={classes.titleMata}>{title}</Typography>
            {!mobile && <img className={classes.MATALogo} src={'/img/analytics/mata_logo.png'} />}
        </div>}
        {!isMata && <Typography className={classes.title}>{title}</Typography>}
        <Typography className={classes.verbiage}>{verbiage}</Typography>
        <Paper className={clsx(classes.childrenContainer, isMata && classes.childrenContainerMata)}>{children}</Paper>
    </Paper>)
}

RegistrationContainer.propTypes = {
    children: PropTypes.object,
    classes: PropTypes.object,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(RegistrationContainer, styles)
